import React from "react";
import LandingPage from "auth/home/landingPage";
import { Route, Routes } from "react-router-dom";
import Login from "auth/login/login";
import ResetPassword from "auth/resetPassword/resetPassword";
import PasswordSent from "auth/passwordSent/passwordSent";
import SignUpHome from "auth/signUp/signUpHome";
import SignupCustomer from "auth/signUp/signup-customer/signup-customer";
import SignupInvited from "auth/signUp/signup-invited/signupInvited";
import VerifiedPassword from "auth/verified-password/verifiedPassword";
import { GuestNavbar } from "shared/component/navbar/navbar";

function AuthRoutes() {
  return (
    <div className="authApp">
      <GuestNavbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/password-sent" element={<PasswordSent />} />
        <Route path="signup" element={<SignUpHome />} />
        <Route path="/signup/customer" element={<SignupCustomer />} />
        <Route path="/granted-user/signup/:token" element={<SignupInvited />} />
        <Route path="/verify-password" element={<VerifiedPassword />} />
      </Routes>
    </div>
  );
}

export default AuthRoutes;
